// Booking sources that come from a synced OTA calendar (vs. Manual/Website).
// Keep in sync with DEFAULT_FEEDS in backend/services/icalSyncService.js.
export const OTA_PLATFORMS = new Set(["Airbnb", "Booking.com", "Agoda", "MakeMyTrip"]);

/**
 * Given the distinct `source` values of the booking(s) blocking a date/room,
 * return a human label — attributing the block to the OTA when every
 * blocking booking came from one, otherwise a generic "Booked".
 */
export function blockedLabel(sources) {
  if (!sources || sources.length === 0) return "Booked";
  const otas = sources.filter(s => OTA_PLATFORMS.has(s));
  if (otas.length !== sources.length) return "Booked";
  return otas.length === 1 ? `Blocked via ${otas[0]}` : `Blocked via ${otas.join(", ")}`;
}
